const { REACT_APP_DEPLOY_PHASE } = process.env
export const LOUNGE_BOARD_SERVICE_TYPE = 'KAKAOKEYWORD'
export const LOUNGE_BOARD_PHASE =
  REACT_APP_DEPLOY_PHASE === 'production' || REACT_APP_DEPLOY_PHASE === 'cbt'
    ? 'prod'
    : 'sandbox'
export const LOUNGE_BOARD_ID_OFFSET = 30000
